import classNames from "classnames";
import React from "react";
import { styled } from "@linaria/react";
import Option from "@ui/Option";
import { color, fonts } from "@ui";
import type { UserRole } from "../../../api/useUsers";
import { AnimatedTick } from "./ProjectRolesOptions";

const StyledOption = styled(Option)`
  height: initial;
  padding: 10px 16px;
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  &.disabled {
    opacity: 0.4;
  }
`;

const OptionTitle = styled.p`
  font: ${fonts.body1SemiBold};
  color: ${color.carbon900};
`;

const OptionDescription = styled.p`
  font: ${fonts.body2};
  font-weight: 500;
  color: ${color.carbon800};
  max-width: 250px;
  white-space: normal;
`;

export interface RoleOption {
  label: string;
  description: string;
  value: Exclude<UserRole, null>;
  disabled?: boolean;
}

function RolesOptions({
  options,
  currentSelection,
  onClick,
}: {
  options: RoleOption[];
  currentSelection: UserRole;
  onClick: (role: Exclude<UserRole, null>) => void;
}) {
  return (
    <>
      {options.map(option => (
        <StyledOption
          key={option.value}
          onClick={() => onClick(option.value)}
          disabled={option.disabled}
        >
          <ContentWrapper className={classNames({ disabled: option.disabled })}>
            <div>
              <OptionTitle>{option.label}</OptionTitle>
              <OptionDescription>{option.description}</OptionDescription>
            </div>
            {Array.isArray(currentSelection) ? (
              currentSelection.some(cs => cs === option.value) && <AnimatedTick />
            ) : currentSelection === option.value ? (
              <AnimatedTick />
            ) : null}
          </ContentWrapper>
        </StyledOption>
      ))}
    </>
  );
}

export default RolesOptions;
